import {
  CREATE_DAILY_SOLAR_REPORT,
  DELETE_DAILY_SOLAR_REPORT,
  EDIT_DAILY_SOLAR_REPORT,
  RECEIVE_DAILY_SOLAR_REPORTS,
  REQUEST_DAILY_SOLAR_REPORT,
} from '@sophocles/entities/DailySolarReport/dailySolarReportActions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_DAILY_SOLAR_REPORTS: // Read
      return state.merge(action.dailySolarReports);
    case DELETE_DAILY_SOLAR_REPORT: // Delete
      return state.delete(action.dailySolarReport.toString());
    case EDIT_DAILY_SOLAR_REPORT: // Update
    case CREATE_DAILY_SOLAR_REPORT: // Create
    case REQUEST_DAILY_SOLAR_REPORT:
    default:
      return state;
  }
}

export function dailySolarReportReducer(state = Map(), action) {
  switch (action.type) {
    case CREATE_DAILY_SOLAR_REPORT:
    case DELETE_DAILY_SOLAR_REPORT:
    case RECEIVE_DAILY_SOLAR_REPORTS:
    case EDIT_DAILY_SOLAR_REPORT:
    case REQUEST_DAILY_SOLAR_REPORT:
      return getState(state, action);
    default:
      return state;
  }
}
